import * as actions from './ProjectedCashFlowReportActions'

const initialState = {
    YearOptions: []
}

const blankClientItem = {
    is_initialized: false,
    errors: [],
    error_type: null
}

const ProjectedCashFlowReport = (state = initialState, action) => {
    switch (action.type) {
        case actions.RECEIVE_DATA:
            return Object.assign({}, state, {
                YearOptions: action.resp_data.YearOptions,
                [action.clientId]: {
                    ...blankClientItem,
                    ...state[action.clientId],
                    Inflows: action.resp_data.Inflows,
                    InflowsTotals: action.resp_data.InflowsTotals,
                    Outflows: action.resp_data.Outflows,
                    OutflowsTotals: action.resp_data.OutflowsTotals,
                    Milestones: action.resp_data.Milestones,
                    Mode: action.resp_data.Mode,
                    NetCashflow: action.resp_data.NetCashflow,
                    People: action.resp_data.People,
                    Periods: action.resp_data.Periods,
                    PrincipalAges: action.resp_data.PrincipalAges,
                    SpouseAges: action.resp_data.SpouseAges,
                    is_initialized: true,
                    errors: blankClientItem.errors,
                    error_type: blankClientItem.error_type,
                }
            })
        case actions.SET_ERRORS:
            return Object.assign({}, state, {
                [action.clientId]: {
                    ...state[action.clientId],
                    errors: action.errors
                }
            })
        case actions.SET_ERROR_TYPE:
            return Object.assign({}, state, {
                [action.clientId]: {
                    ...state[action.clientId],
                    error_type: action.error_type
                }
            })
        case actions.SET_CURRENT:
            return Object.assign({}, state, {
                [action.clientId]: {
                    ...state[action.clientId],
                    is_current: action.is_current
                }
            })
        default:
            return state
    }
}

export default ProjectedCashFlowReport
